export default "__VITE_ASSET__2328b7b7__"